module.exports = __webpack_public_path__ + "static/img/data-dashboard.d838807f.png";